import type { Moment } from 'moment';
import { useSelector } from 'react-redux';

import { getBasketMode } from '@wecasa/common/src/ducks/customer/basket';
import { getModifiedBooking } from '@wecasa/common/src/ducks/customer/basket-selectors';
import { getCreatedAt } from '@wecasa/common/src/utils/booking';
import { FORMATS, formatDate } from '@wecasa/common/src/utils/date';

const formatDateForAPI = (date: Moment) => formatDate(date, FORMATS.DATETIME.TIMESTAMPS);

export const useVersionedAt = () => {
  const mode = useSelector(getBasketMode);
  const modificationBooking = useSelector(getModifiedBooking);

  return mode === 'modification' && modificationBooking
    ? formatDateForAPI(getCreatedAt(modificationBooking))
    : undefined;
};
